import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { map, mapTo, share, switchMap } from 'rxjs/operators';
import { EMPTY, throwError, of } from 'rxjs';

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var Archived = /*#__PURE__*/function (Archived) {
  Archived[Archived["ARCHIVED_ANY"] = 0] = "ARCHIVED_ANY";
  Archived[Archived["ARCHIVED_YES"] = 1] = "ARCHIVED_YES";
  Archived[Archived["ARCHIVED_NO"] = 2] = "ARCHIVED_NO";
  return Archived;
}(Archived || {});
var Campaign = /*#__PURE__*/function (Campaign) {
  Campaign[Campaign["CAMPAIGN_ANY"] = 0] = "CAMPAIGN_ANY";
  Campaign[Campaign["CAMPAIGN_ON"] = 1] = "CAMPAIGN_ON";
  Campaign[Campaign["CAMPAIGN_OFF"] = 2] = "CAMPAIGN_OFF";
  return Campaign;
}(Campaign || {});
var LifecycleStage = /*#__PURE__*/function (LifecycleStage) {
  LifecycleStage[LifecycleStage["LIFECYCLE_STAGE_UNSET"] = 0] = "LIFECYCLE_STAGE_UNSET";
  LifecycleStage[LifecycleStage["LIFECYCLE_STAGE_LEAD"] = 1] = "LIFECYCLE_STAGE_LEAD";
  LifecycleStage[LifecycleStage["LIFECYCLE_STAGE_PROSPECT"] = 2] = "LIFECYCLE_STAGE_PROSPECT";
  LifecycleStage[LifecycleStage["LIFECYCLE_STAGE_CUSTOMER"] = 3] = "LIFECYCLE_STAGE_CUSTOMER";
  return LifecycleStage;
}(LifecycleStage || {});
var Snapshot = /*#__PURE__*/function (Snapshot) {
  Snapshot[Snapshot["SNAPSHOT_ANY"] = 0] = "SNAPSHOT_ANY";
  Snapshot[Snapshot["SNAPSHOT_SENT"] = 1] = "SNAPSHOT_SENT";
  Snapshot[Snapshot["SNAPSHOT_NOT_SENT"] = 2] = "SNAPSHOT_NOT_SENT";
  return Snapshot;
}(Snapshot || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var ActionCategory = /*#__PURE__*/function (ActionCategory) {
  ActionCategory[ActionCategory["ACTION_CATEGORY_UNKNOWN"] = 0] = "ACTION_CATEGORY_UNKNOWN";
  ActionCategory[ActionCategory["ACTION_CATEGORY_CLICK"] = 1] = "ACTION_CATEGORY_CLICK";
  ActionCategory[ActionCategory["ACTION_CATEGORY_VIEW"] = 2] = "ACTION_CATEGORY_VIEW";
  ActionCategory[ActionCategory["ACTION_CATEGORY_LINGER"] = 3] = "ACTION_CATEGORY_LINGER";
  ActionCategory[ActionCategory["ACTION_CATEGORY_TYPED"] = 4] = "ACTION_CATEGORY_TYPED";
  ActionCategory[ActionCategory["ACTION_CATEGORY_PURCHASED"] = 5] = "ACTION_CATEGORY_PURCHASED";
  ActionCategory[ActionCategory["ACTION_CATEGORY_ADDED_TO_CART"] = 6] = "ACTION_CATEGORY_ADDED_TO_CART";
  return ActionCategory;
}(ActionCategory || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var TicketPriority = /*#__PURE__*/function (TicketPriority) {
  TicketPriority[TicketPriority["TICKET_PRIORITY_UNSET"] = 0] = "TICKET_PRIORITY_UNSET";
  TicketPriority[TicketPriority["TICKET_PRIORITY_LOW"] = 1] = "TICKET_PRIORITY_LOW";
  TicketPriority[TicketPriority["TICKET_PRIORITY_MEDIUM"] = 2] = "TICKET_PRIORITY_MEDIUM";
  TicketPriority[TicketPriority["TICKET_PRIORITY_HIGH"] = 3] = "TICKET_PRIORITY_HIGH";
  TicketPriority[TicketPriority["TICKET_PRIORITY_URGENT"] = 4] = "TICKET_PRIORITY_URGENT";
  return TicketPriority;
}(TicketPriority || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var CriteriaMatchType = /*#__PURE__*/function (CriteriaMatchType) {
  CriteriaMatchType[CriteriaMatchType["CRITERIA_MATCH_TYPE_ALL"] = 0] = "CRITERIA_MATCH_TYPE_ALL";
  CriteriaMatchType[CriteriaMatchType["CRITERIA_MATCH_TYPE_ANY"] = 1] = "CRITERIA_MATCH_TYPE_ANY";
  return CriteriaMatchType;
}(CriteriaMatchType || {});
var TagMatchType = /*#__PURE__*/function (TagMatchType) {
  TagMatchType[TagMatchType["TAG_MATCH_TYPE_ALL"] = 0] = "TAG_MATCH_TYPE_ALL";
  TagMatchType[TagMatchType["TAG_MATCH_TYPE_ANY"] = 1] = "TAG_MATCH_TYPE_ANY";
  return TagMatchType;
}(TagMatchType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var Frequency = /*#__PURE__*/function (Frequency) {
  Frequency[Frequency["FREQUENCY_ONETIME"] = 0] = "FREQUENCY_ONETIME";
  Frequency[Frequency["FREQUENCY_DAILY"] = 1] = "FREQUENCY_DAILY";
  Frequency[Frequency["FREQUENCY_WEEKLY"] = 2] = "FREQUENCY_WEEKLY";
  Frequency[Frequency["FREQUENCY_BIWEEKLY"] = 3] = "FREQUENCY_BIWEEKLY";
  Frequency[Frequency["FREQUENCY_MONTHLY"] = 4] = "FREQUENCY_MONTHLY";
  Frequency[Frequency["FREQUENCY_YEARLY"] = 5] = "FREQUENCY_YEARLY";
  return Frequency;
}(Frequency || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var Currency = /*#__PURE__*/function (Currency) {
  Currency[Currency["USD"] = 0] = "USD";
  Currency[Currency["CAD"] = 1] = "CAD";
  Currency[Currency["EUR"] = 2] = "EUR";
  Currency[Currency["AUD"] = 3] = "AUD";
  Currency[Currency["GBP"] = 4] = "GBP";
  Currency[Currency["NZD"] = 5] = "NZD";
  Currency[Currency["ZAR"] = 6] = "ZAR";
  return Currency;
}(Currency || {});
var DurationPeriod = /*#__PURE__*/function (DurationPeriod) {
  DurationPeriod[DurationPeriod["UNSPECIFIED"] = 0] = "UNSPECIFIED";
  DurationPeriod[DurationPeriod["MONTH"] = 1] = "MONTH";
  DurationPeriod[DurationPeriod["YEAR"] = 2] = "YEAR";
  DurationPeriod[DurationPeriod["DAY"] = 3] = "DAY";
  DurationPeriod[DurationPeriod["WEEK"] = 4] = "WEEK";
  return DurationPeriod;
}(DurationPeriod || {});
var RevenuePeriod = /*#__PURE__*/function (RevenuePeriod) {
  RevenuePeriod[RevenuePeriod["ONETIME"] = 0] = "ONETIME";
  RevenuePeriod[RevenuePeriod["DAILY"] = 1] = "DAILY";
  RevenuePeriod[RevenuePeriod["WEEKLY"] = 2] = "WEEKLY";
  RevenuePeriod[RevenuePeriod["BIWEEKLY"] = 3] = "BIWEEKLY";
  RevenuePeriod[RevenuePeriod["MONTHLY"] = 4] = "MONTHLY";
  RevenuePeriod[RevenuePeriod["YEARLY"] = 5] = "YEARLY";
  return RevenuePeriod;
}(RevenuePeriod || {});
// *********************************

function enumStringToValue$a(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Salesperson {
  static fromProto(proto) {
    let m = new Salesperson();
    m = Object.assign(m, proto);
    if (proto.lastLogin) {
      m.lastLogin = new Date(proto.lastLogin);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.salespersonId !== 'undefined') {
      toReturn['salespersonId'] = this.salespersonId;
    }
    if (typeof this.firstName !== 'undefined') {
      toReturn['firstName'] = this.firstName;
    }
    if (typeof this.lastName !== 'undefined') {
      toReturn['lastName'] = this.lastName;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.phoneNumber !== 'undefined') {
      toReturn['phoneNumber'] = this.phoneNumber;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.countryCode !== 'undefined') {
      toReturn['countryCode'] = this.countryCode;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.photoUrlHttps !== 'undefined') {
      toReturn['photoUrlHttps'] = this.photoUrlHttps;
    }
    if (typeof this.lastLogin !== 'undefined' && this.lastLogin !== null) {
      toReturn['lastLogin'] = 'toApiJson' in this.lastLogin ? this.lastLogin.toApiJson() : this.lastLogin;
    }
    if (typeof this.jobTitle !== 'undefined') {
      toReturn['jobTitle'] = this.jobTitle;
    }
    if (typeof this.isSalesManager !== 'undefined') {
      toReturn['isSalesManager'] = this.isSalesManager;
    }
    if (typeof this.meetingBookingUrl !== 'undefined') {
      toReturn['meetingBookingUrl'] = this.meetingBookingUrl;
    }
    return toReturn;
  }
}
function enumStringToValue$9(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class SalesTeam {
  static fromProto(proto) {
    let m = new SalesTeam();
    m = Object.assign(m, proto);
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.teamName !== 'undefined') {
      toReturn['teamName'] = this.teamName;
    }
    if (typeof this.groupId !== 'undefined') {
      toReturn['groupId'] = this.groupId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    return toReturn;
  }
}
function enumStringToValue$8(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class SalesActivity {
  static fromProto(proto) {
    let m = new SalesActivity();
    m = Object.assign(m, proto);
    if (proto.key) {
      m.key = SalesActivityKey.fromProto(proto.key);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.lastEdited) {
      m.lastEdited = new Date(proto.lastEdited);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined' && this.key !== null) {
      toReturn['key'] = 'toApiJson' in this.key ? this.key.toApiJson() : this.key;
    }
    if (typeof this.opportunityId !== 'undefined') {
      toReturn['opportunityId'] = this.opportunityId;
    }
    if (typeof this.salespersonId !== 'undefined') {
      toReturn['salespersonId'] = this.salespersonId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.salesStatus !== 'undefined') {
      toReturn['salesStatus'] = this.salesStatus;
    }
    if (typeof this.previousSalesStatus !== 'undefined') {
      toReturn['previousSalesStatus'] = this.previousSalesStatus;
    }
    if (typeof this.salespersonAction !== 'undefined') {
      toReturn['salespersonAction'] = this.salespersonAction;
    }
    if (typeof this.customActionName !== 'undefined') {
      toReturn['customActionName'] = this.customActionName;
    }
    if (typeof this.productName !== 'undefined') {
      toReturn['productName'] = this.productName;
    }
    if (typeof this.productPrice !== 'undefined') {
      toReturn['productPrice'] = this.productPrice;
    }
    if (typeof this.connected !== 'undefined') {
      toReturn['connected'] = this.connected;
    }
    if (typeof this.notes !== 'undefined') {
      toReturn['notes'] = this.notes;
    }
    if (typeof this.closedLostReason !== 'undefined') {
      toReturn['closedLostReason'] = this.closedLostReason;
    }
    if (typeof this.audioKey !== 'undefined') {
      toReturn['audioKey'] = this.audioKey;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.lastEdited !== 'undefined' && this.lastEdited !== null) {
      toReturn['lastEdited'] = 'toApiJson' in this.lastEdited ? this.lastEdited.toApiJson() : this.lastEdited;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    if (typeof this.opportunityName !== 'undefined') {
      toReturn['opportunityName'] = this.opportunityName;
    }
    if (typeof this.salesPersonName !== 'undefined') {
      toReturn['salesPersonName'] = this.salesPersonName;
    }
    return toReturn;
  }
}
class SalesActivityKey {
  static fromProto(proto) {
    let m = new SalesActivityKey();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.salesActivityId !== 'undefined') {
      toReturn['salesActivityId'] = this.salesActivityId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
function enumStringToValue$7(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Business {
  static fromProto(proto) {
    let m = new Business();
    m = Object.assign(m, proto);
    if (proto.hotness) {
      m.hotness = parseInt(proto.hotness, 10);
    }
    if (proto.lastSalesActivityDate) {
      m.lastSalesActivityDate = new Date(proto.lastSalesActivityDate);
    }
    if (proto.lastCustomerActivityDate) {
      m.lastCustomerActivityDate = new Date(proto.lastCustomerActivityDate);
    }
    if (proto.latestSnapshotExpiry) {
      m.latestSnapshotExpiry = new Date(proto.latestSnapshotExpiry);
    }
    if (proto.lastConnectedDate) {
      m.lastConnectedDate = new Date(proto.lastConnectedDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.hotness !== 'undefined') {
      toReturn['hotness'] = this.hotness;
    }
    if (typeof this.city !== 'undefined') {
      toReturn['city'] = this.city;
    }
    if (typeof this.zip !== 'undefined') {
      toReturn['zip'] = this.zip;
    }
    if (typeof this.address !== 'undefined') {
      toReturn['address'] = this.address;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.country !== 'undefined') {
      toReturn['country'] = this.country;
    }
    if (typeof this.phoneNumber !== 'undefined') {
      toReturn['phoneNumber'] = this.phoneNumber;
    }
    if (typeof this.salespersonId !== 'undefined') {
      toReturn['salespersonId'] = this.salespersonId;
    }
    if (typeof this.lastSalesActivityDate !== 'undefined' && this.lastSalesActivityDate !== null) {
      toReturn['lastSalesActivityDate'] = 'toApiJson' in this.lastSalesActivityDate ? this.lastSalesActivityDate.toApiJson() : this.lastSalesActivityDate;
    }
    if (typeof this.lastCustomerActivityDate !== 'undefined' && this.lastCustomerActivityDate !== null) {
      toReturn['lastCustomerActivityDate'] = 'toApiJson' in this.lastCustomerActivityDate ? this.lastCustomerActivityDate.toApiJson() : this.lastCustomerActivityDate;
    }
    if (typeof this.salesStatus !== 'undefined') {
      toReturn['salesStatus'] = this.salesStatus;
    }
    if (typeof this.isRead !== 'undefined') {
      toReturn['isRead'] = this.isRead;
    }
    if (typeof this.salesPersonAction !== 'undefined') {
      toReturn['salesPersonAction'] = this.salesPersonAction;
    }
    if (typeof this.latestSnapshotExpiry !== 'undefined' && this.latestSnapshotExpiry !== null) {
      toReturn['latestSnapshotExpiry'] = 'toApiJson' in this.latestSnapshotExpiry ? this.latestSnapshotExpiry.toApiJson() : this.latestSnapshotExpiry;
    }
    if (typeof this.snapshotOrCampaignEmailStatus !== 'undefined') {
      toReturn['snapshotOrCampaignEmailStatus'] = this.snapshotOrCampaignEmailStatus;
    }
    if (typeof this.activityType !== 'undefined') {
      toReturn['activityType'] = this.activityType;
    }
    if (typeof this.lastConnectedDate !== 'undefined' && this.lastConnectedDate !== null) {
      toReturn['lastConnectedDate'] = 'toApiJson' in this.lastConnectedDate ? this.lastConnectedDate.toApiJson() : this.lastConnectedDate;
    }
    if (typeof this.lifecycleStage !== 'undefined') {
      toReturn['lifecycleStage'] = this.lifecycleStage;
    }
    return toReturn;
  }
}
class BusinessPagedResponseMetadata {
  static fromProto(proto) {
    let m = new BusinessPagedResponseMetadata();
    m = Object.assign(m, proto);
    if (proto.totalResults) {
      m.totalResults = parseInt(proto.totalResults, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.totalResults !== 'undefined') {
      toReturn['totalResults'] = this.totalResults;
    }
    return toReturn;
  }
}
class BusinessSearchFilters {
  static fromProto(proto) {
    let m = new BusinessSearchFilters();
    m = Object.assign(m, proto);
    if (proto.fromDate) {
      m.fromDate = new Date(proto.fromDate);
    }
    if (proto.toDate) {
      m.toDate = new Date(proto.toDate);
    }
    if (proto.archived) {
      m.archived = enumStringToValue$7(Archived, proto.archived);
    }
    if (proto.onCampaign) {
      m.onCampaign = enumStringToValue$7(Campaign, proto.onCampaign);
    }
    if (proto.snapshotSent) {
      m.snapshotSent = enumStringToValue$7(Snapshot, proto.snapshotSent);
    }
    if (proto.lifecycleStage) {
      m.lifecycleStage = enumStringToValue$7(LifecycleStage, proto.lifecycleStage);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.salesStatuses !== 'undefined') {
      toReturn['salesStatuses'] = this.salesStatuses;
    }
    if (typeof this.salesAction !== 'undefined') {
      toReturn['salesAction'] = this.salesAction;
    }
    if (typeof this.fromDate !== 'undefined' && this.fromDate !== null) {
      toReturn['fromDate'] = 'toApiJson' in this.fromDate ? this.fromDate.toApiJson() : this.fromDate;
    }
    if (typeof this.toDate !== 'undefined' && this.toDate !== null) {
      toReturn['toDate'] = 'toApiJson' in this.toDate ? this.toDate.toApiJson() : this.toDate;
    }
    if (typeof this.archived !== 'undefined') {
      toReturn['archived'] = this.archived;
    }
    if (typeof this.accountTags !== 'undefined') {
      toReturn['accountTags'] = this.accountTags;
    }
    if (typeof this.businessCategories !== 'undefined') {
      toReturn['businessCategories'] = this.businessCategories;
    }
    if (typeof this.onCampaign !== 'undefined') {
      toReturn['onCampaign'] = this.onCampaign;
    }
    if (typeof this.snapshotSent !== 'undefined') {
      toReturn['snapshotSent'] = this.snapshotSent;
    }
    if (typeof this.query !== 'undefined') {
      toReturn['query'] = this.query;
    }
    if (typeof this.assignees !== 'undefined') {
      toReturn['assignees'] = this.assignees;
    }
    if (typeof this.goal !== 'undefined') {
      toReturn['goal'] = this.goal;
    }
    if (typeof this.trainingPriorities !== 'undefined') {
      toReturn['trainingPriorities'] = this.trainingPriorities;
    }
    if (typeof this.customFieldPartnerId !== 'undefined') {
      toReturn['customFieldPartnerId'] = this.customFieldPartnerId;
    }
    if (typeof this.lifecycleStage !== 'undefined') {
      toReturn['lifecycleStage'] = this.lifecycleStage;
    }
    return toReturn;
  }
}
class BusinessSearchSortOptions {
  static fromProto(proto) {
    let m = new BusinessSearchSortOptions();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sortKey !== 'undefined') {
      toReturn['sortKey'] = this.sortKey;
    }
    if (typeof this.sortAscending !== 'undefined') {
      toReturn['sortAscending'] = this.sortAscending;
    }
    return toReturn;
  }
}
function enumStringToValue$6(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class BulkUploadUserActionsRequest {
  static fromProto(proto) {
    let m = new BulkUploadUserActionsRequest();
    m = Object.assign(m, proto);
    if (proto.userActions) {
      m.userActions = proto.userActions.map(UserActionsRequest.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userActions !== 'undefined' && this.userActions !== null) {
      toReturn['userActions'] = 'toApiJson' in this.userActions ? this.userActions.toApiJson() : this.userActions;
    }
    return toReturn;
  }
}
class GetUserActionsRequest {
  static fromProto(proto) {
    let m = new GetUserActionsRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class UploadUserActionForCustomerIDRequest {
  static fromProto(proto) {
    let m = new UploadUserActionForCustomerIDRequest();
    m = Object.assign(m, proto);
    if (proto.category) {
      m.category = enumStringToValue$6(ActionCategory, proto.category);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.category !== 'undefined') {
      toReturn['category'] = this.category;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    return toReturn;
  }
}
class UserAction {
  static fromProto(proto) {
    let m = new UserAction();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.category) {
      m.category = enumStringToValue$6(ActionCategory, proto.category);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.category !== 'undefined') {
      toReturn['category'] = this.category;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    return toReturn;
  }
}
class UserActionsPagedResponseMetadata {
  static fromProto(proto) {
    let m = new UserActionsPagedResponseMetadata();
    m = Object.assign(m, proto);
    if (proto.totalResults) {
      m.totalResults = parseInt(proto.totalResults, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.totalResults !== 'undefined') {
      toReturn['totalResults'] = this.totalResults;
    }
    return toReturn;
  }
}
class UserActionsRequest {
  static fromProto(proto) {
    let m = new UserActionsRequest();
    m = Object.assign(m, proto);
    if (proto.category) {
      m.category = enumStringToValue$6(ActionCategory, proto.category);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.category !== 'undefined') {
      toReturn['category'] = this.category;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    return toReturn;
  }
}
class UserActionsResponse {
  static fromProto(proto) {
    let m = new UserActionsResponse();
    m = Object.assign(m, proto);
    if (proto.userActions) {
      m.userActions = proto.userActions.map(UserAction.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = UserActionsPagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userActions !== 'undefined' && this.userActions !== null) {
      toReturn['userActions'] = 'toApiJson' in this.userActions ? this.userActions.toApiJson() : this.userActions;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
function enumStringToValue$5(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Contact {
  static fromProto(proto) {
    let m = new Contact();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.contactId !== 'undefined') {
      toReturn['contactId'] = this.contactId;
    }
    if (typeof this.firstName !== 'undefined') {
      toReturn['firstName'] = this.firstName;
    }
    if (typeof this.lastName !== 'undefined') {
      toReturn['lastName'] = this.lastName;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.phoneNumber !== 'undefined') {
      toReturn['phoneNumber'] = this.phoneNumber;
    }
    if (typeof this.phoneExtension !== 'undefined') {
      toReturn['phoneExtension'] = this.phoneExtension;
    }
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.notes !== 'undefined') {
      toReturn['notes'] = this.notes;
    }
    if (typeof this.vbcUserId !== 'undefined') {
      toReturn['vbcUserId'] = this.vbcUserId;
    }
    if (typeof this.deleted !== 'undefined') {
      toReturn['deleted'] = this.deleted;
    }
    if (typeof this.deletedDate !== 'undefined') {
      toReturn['deletedDate'] = this.deletedDate;
    }
    if (typeof this.created !== 'undefined') {
      toReturn['created'] = this.created;
    }
    if (typeof this.updated !== 'undefined') {
      toReturn['updated'] = this.updated;
    }
    return toReturn;
  }
}
function enumStringToValue$4(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Access {
  static fromProto(proto) {
    let m = new Access();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.scope !== 'undefined') {
      toReturn['scope'] = this.scope;
    }
    if (typeof this.public !== 'undefined') {
      toReturn['public'] = this.public;
    }
    return toReturn;
  }
}
function enumStringToValue$3(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Attachment {
  static fromProto(proto) {
    let m = new Attachment();
    m = Object.assign(m, proto);
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.thumbnailUrl !== 'undefined') {
      toReturn['thumbnailUrl'] = this.thumbnailUrl;
    }
    return toReturn;
  }
}
class Conversation {
  static fromProto(proto) {
    let m = new Conversation();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.attachments) {
      m.attachments = proto.attachments.map(Attachment.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.message !== 'undefined') {
      toReturn['message'] = this.message;
    }
    if (typeof this.fromEmail !== 'undefined') {
      toReturn['fromEmail'] = this.fromEmail;
    }
    if (typeof this.toEmails !== 'undefined') {
      toReturn['toEmails'] = this.toEmails;
    }
    if (typeof this.ticketId !== 'undefined') {
      toReturn['ticketId'] = this.ticketId;
    }
    if (typeof this.attachments !== 'undefined' && this.attachments !== null) {
      toReturn['attachments'] = 'toApiJson' in this.attachments ? this.attachments.toApiJson() : this.attachments;
    }
    return toReturn;
  }
}
class Pagination {
  static fromProto(proto) {
    let m = new Pagination();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pageIndex !== 'undefined') {
      toReturn['pageIndex'] = this.pageIndex;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class Ticket {
  static fromProto(proto) {
    let m = new Ticket();
    m = Object.assign(m, proto);
    if (proto.id) {
      m.id = parseInt(proto.id, 10);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.requested) {
      m.requested = new Date(proto.requested);
    }
    if (proto.requesterId) {
      m.requesterId = parseInt(proto.requesterId, 10);
    }
    if (proto.responderId) {
      m.responderId = parseInt(proto.responderId, 10);
    }
    if (proto.statusId) {
      m.statusId = parseInt(proto.statusId, 10);
    }
    if (proto.sourceId) {
      m.sourceId = parseInt(proto.sourceId, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.requested !== 'undefined' && this.requested !== null) {
      toReturn['requested'] = 'toApiJson' in this.requested ? this.requested.toApiJson() : this.requested;
    }
    if (typeof this.requesterId !== 'undefined') {
      toReturn['requesterId'] = this.requesterId;
    }
    if (typeof this.responderId !== 'undefined') {
      toReturn['responderId'] = this.responderId;
    }
    if (typeof this.subject !== 'undefined') {
      toReturn['subject'] = this.subject;
    }
    if (typeof this.statusId !== 'undefined') {
      toReturn['statusId'] = this.statusId;
    }
    if (typeof this.sourceId !== 'undefined') {
      toReturn['sourceId'] = this.sourceId;
    }
    return toReturn;
  }
}
function enumStringToValue$2(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AutoAssignCriteriaAccountOriginCriteria {
  static fromProto(proto) {
    let m = new AutoAssignCriteriaAccountOriginCriteria();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.origin !== 'undefined') {
      toReturn['origin'] = this.origin;
    }
    return toReturn;
  }
}
class AddContactToCampaignRequest {
  static fromProto(proto) {
    let m = new AddContactToCampaignRequest();
    m = Object.assign(m, proto);
    if (proto.contact) {
      m.contact = AddContactToCampaignRequestRecipient.fromProto(proto.contact);
    }
    if (proto.sender) {
      m.sender = AddContactToCampaignRequestSender.fromProto(proto.sender);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.campaignId !== 'undefined') {
      toReturn['campaignId'] = this.campaignId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.contact !== 'undefined' && this.contact !== null) {
      toReturn['contact'] = 'toApiJson' in this.contact ? this.contact.toApiJson() : this.contact;
    }
    if (typeof this.sender !== 'undefined' && this.sender !== null) {
      toReturn['sender'] = 'toApiJson' in this.sender ? this.sender.toApiJson() : this.sender;
    }
    return toReturn;
  }
}
class AutoAssignRuleAppKey {
  static fromProto(proto) {
    let m = new AutoAssignRuleAppKey();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.editionId !== 'undefined') {
      toReturn['editionId'] = this.editionId;
    }
    return toReturn;
  }
}
class AssignSalesTaskRequest {
  static fromProto(proto) {
    let m = new AssignSalesTaskRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.taskId !== 'undefined') {
      toReturn['taskId'] = this.taskId;
    }
    if (typeof this.salespersonUserId !== 'undefined') {
      toReturn['salespersonUserId'] = this.salespersonUserId;
    }
    return toReturn;
  }
}
class AutoAssignCriteria {
  static fromProto(proto) {
    let m = new AutoAssignCriteria();
    m = Object.assign(m, proto);
    if (proto.locationCriteria) {
      m.locationCriteria = AutoAssignCriteriaLocationCriteria.fromProto(proto.locationCriteria);
    }
    if (proto.categoryCriteria) {
      m.categoryCriteria = AutoAssignCriteriaCategoryCriteria.fromProto(proto.categoryCriteria);
    }
    if (proto.tagCriteria) {
      m.tagCriteria = AutoAssignCriteriaTagCriteria.fromProto(proto.tagCriteria);
    }
    if (proto.conversionPointCriteria) {
      m.conversionPointCriteria = AutoAssignCriteriaConversionPointCriteria.fromProto(proto.conversionPointCriteria);
    }
    if (proto.accountOriginCriteria) {
      m.accountOriginCriteria = AutoAssignCriteriaAccountOriginCriteria.fromProto(proto.accountOriginCriteria);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.locationCriteria !== 'undefined' && this.locationCriteria !== null) {
      toReturn['locationCriteria'] = 'toApiJson' in this.locationCriteria ? this.locationCriteria.toApiJson() : this.locationCriteria;
    }
    if (typeof this.categoryCriteria !== 'undefined' && this.categoryCriteria !== null) {
      toReturn['categoryCriteria'] = 'toApiJson' in this.categoryCriteria ? this.categoryCriteria.toApiJson() : this.categoryCriteria;
    }
    if (typeof this.tagCriteria !== 'undefined' && this.tagCriteria !== null) {
      toReturn['tagCriteria'] = 'toApiJson' in this.tagCriteria ? this.tagCriteria.toApiJson() : this.tagCriteria;
    }
    if (typeof this.conversionPointCriteria !== 'undefined' && this.conversionPointCriteria !== null) {
      toReturn['conversionPointCriteria'] = 'toApiJson' in this.conversionPointCriteria ? this.conversionPointCriteria.toApiJson() : this.conversionPointCriteria;
    }
    if (typeof this.accountOriginCriteria !== 'undefined' && this.accountOriginCriteria !== null) {
      toReturn['accountOriginCriteria'] = 'toApiJson' in this.accountOriginCriteria ? this.accountOriginCriteria.toApiJson() : this.accountOriginCriteria;
    }
    return toReturn;
  }
}
class AutoAssignRule {
  static fromProto(proto) {
    let m = new AutoAssignRule();
    m = Object.assign(m, proto);
    if (proto.criteria) {
      m.criteria = proto.criteria.map(AutoAssignCriteria.fromProto);
    }
    if (proto.criteriaMatchType) {
      m.criteriaMatchType = enumStringToValue$2(CriteriaMatchType, proto.criteriaMatchType);
    }
    if (proto.appKeys) {
      m.appKeys = proto.appKeys.map(AutoAssignRuleAppKey.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.criteria !== 'undefined' && this.criteria !== null) {
      toReturn['criteria'] = 'toApiJson' in this.criteria ? this.criteria.toApiJson() : this.criteria;
    }
    if (typeof this.salespersonIds !== 'undefined') {
      toReturn['salespersonIds'] = this.salespersonIds;
    }
    if (typeof this.criteriaMatchType !== 'undefined') {
      toReturn['criteriaMatchType'] = this.criteriaMatchType;
    }
    if (typeof this.campaignId !== 'undefined') {
      toReturn['campaignId'] = this.campaignId;
    }
    if (typeof this.appKeys !== 'undefined' && this.appKeys !== null) {
      toReturn['appKeys'] = 'toApiJson' in this.appKeys ? this.appKeys.toApiJson() : this.appKeys;
    }
    return toReturn;
  }
}
class BusinessListRequest {
  static fromProto(proto) {
    let m = new BusinessListRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketIds !== 'undefined') {
      toReturn['marketIds'] = this.marketIds;
    }
    if (typeof this.contactEmail !== 'undefined') {
      toReturn['contactEmail'] = this.contactEmail;
    }
    return toReturn;
  }
}
class BusinessListResponse {
  static fromProto(proto) {
    let m = new BusinessListResponse();
    m = Object.assign(m, proto);
    if (proto.businesses) {
      m.businesses = proto.businesses.map(BusinessListResponseSalestoolBusiness.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businesses !== 'undefined' && this.businesses !== null) {
      toReturn['businesses'] = 'toApiJson' in this.businesses ? this.businesses.toApiJson() : this.businesses;
    }
    return toReturn;
  }
}
class BusinessSearchRequest {
  static fromProto(proto) {
    let m = new BusinessSearchRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = BusinessSearchFilters.fromProto(proto.filters);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    if (proto.sortOptions) {
      m.sortOptions = BusinessSearchSortOptions.fromProto(proto.sortOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.sortOptions !== 'undefined' && this.sortOptions !== null) {
      toReturn['sortOptions'] = 'toApiJson' in this.sortOptions ? this.sortOptions.toApiJson() : this.sortOptions;
    }
    return toReturn;
  }
}
class BusinessSearchResponse {
  static fromProto(proto) {
    let m = new BusinessSearchResponse();
    m = Object.assign(m, proto);
    if (proto.businesses) {
      m.businesses = proto.businesses.map(Business.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = BusinessPagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businesses !== 'undefined' && this.businesses !== null) {
      toReturn['businesses'] = 'toApiJson' in this.businesses ? this.businesses.toApiJson() : this.businesses;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class AutoAssignCriteriaCategoryCriteria {
  static fromProto(proto) {
    let m = new AutoAssignCriteriaCategoryCriteria();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.categories !== 'undefined') {
      toReturn['categories'] = this.categories;
    }
    return toReturn;
  }
}
class ContactCreateRequest {
  static fromProto(proto) {
    let m = new ContactCreateRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.firstName !== 'undefined') {
      toReturn['firstName'] = this.firstName;
    }
    if (typeof this.lastName !== 'undefined') {
      toReturn['lastName'] = this.lastName;
    }
    if (typeof this.phoneNumber !== 'undefined') {
      toReturn['phoneNumber'] = this.phoneNumber;
    }
    if (typeof this.phoneNumberCountry !== 'undefined') {
      toReturn['phoneNumberCountry'] = this.phoneNumberCountry;
    }
    if (typeof this.phoneExtension !== 'undefined') {
      toReturn['phoneExtension'] = this.phoneExtension;
    }
    if (typeof this.notes !== 'undefined') {
      toReturn['notes'] = this.notes;
    }
    return toReturn;
  }
}
class ContactCreateResponse {
  static fromProto(proto) {
    let m = new ContactCreateResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.contactId !== 'undefined') {
      toReturn['contactId'] = this.contactId;
    }
    return toReturn;
  }
}
class AutoAssignCriteriaConversionPointCriteria {
  static fromProto(proto) {
    let m = new AutoAssignCriteriaConversionPointCriteria();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.conversionPoint !== 'undefined') {
      toReturn['conversionPoint'] = this.conversionPoint;
    }
    return toReturn;
  }
}
class CreateBusinessActivityRequest {
  static fromProto(proto) {
    let m = new CreateBusinessActivityRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.activityType !== 'undefined') {
      toReturn['activityType'] = this.activityType;
    }
    if (typeof this.activityDetail !== 'undefined') {
      toReturn['activityDetail'] = this.activityDetail;
    }
    if (typeof this.productName !== 'undefined') {
      toReturn['productName'] = this.productName;
    }
    if (typeof this.productId !== 'undefined') {
      toReturn['productId'] = this.productId;
    }
    if (typeof this.doNotSendEmail !== 'undefined') {
      toReturn['doNotSendEmail'] = this.doNotSendEmail;
    }
    return toReturn;
  }
}
class CreateOrUpdateAutoAssignConfigRequest {
  static fromProto(proto) {
    let m = new CreateOrUpdateAutoAssignConfigRequest();
    m = Object.assign(m, proto);
    if (proto.rules) {
      m.rules = proto.rules.map(AutoAssignRule.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.rules !== 'undefined' && this.rules !== null) {
      toReturn['rules'] = 'toApiJson' in this.rules ? this.rules.toApiJson() : this.rules;
    }
    return toReturn;
  }
}
class CreateSalesActivityRequest {
  static fromProto(proto) {
    let m = new CreateSalesActivityRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.salespersonId !== 'undefined') {
      toReturn['salespersonId'] = this.salespersonId;
    }
    if (typeof this.submittedBy !== 'undefined') {
      toReturn['submittedBy'] = this.submittedBy;
    }
    if (typeof this.action !== 'undefined') {
      toReturn['action'] = this.action;
    }
    if (typeof this.customActionName !== 'undefined') {
      toReturn['customActionName'] = this.customActionName;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.notes !== 'undefined') {
      toReturn['notes'] = this.notes;
    }
    return toReturn;
  }
}
class CreateSalesActivityResponse {
  static fromProto(proto) {
    let m = new CreateSalesActivityResponse();
    m = Object.assign(m, proto);
    if (proto.salesActivity) {
      m.salesActivity = SalesActivity.fromProto(proto.salesActivity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.salesActivity !== 'undefined' && this.salesActivity !== null) {
      toReturn['salesActivity'] = 'toApiJson' in this.salesActivity ? this.salesActivity.toApiJson() : this.salesActivity;
    }
    return toReturn;
  }
}
class CreateSalesTaskRequest {
  static fromProto(proto) {
    let m = new CreateSalesTaskRequest();
    m = Object.assign(m, proto);
    if (proto.dueDate) {
      m.dueDate = new Date(proto.dueDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.dueDate !== 'undefined' && this.dueDate !== null) {
      toReturn['dueDate'] = 'toApiJson' in this.dueDate ? this.dueDate.toApiJson() : this.dueDate;
    }
    if (typeof this.salespersonIds !== 'undefined') {
      toReturn['salespersonIds'] = this.salespersonIds;
    }
    return toReturn;
  }
}
class CreateSalesTaskResponse {
  static fromProto(proto) {
    let m = new CreateSalesTaskResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.taskId !== 'undefined') {
      toReturn['taskId'] = this.taskId;
    }
    if (typeof this.taskNamespace !== 'undefined') {
      toReturn['taskNamespace'] = this.taskNamespace;
    }
    return toReturn;
  }
}
class ExternalIdentifierCreateRequest {
  static fromProto(proto) {
    let m = new ExternalIdentifierCreateRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.externalIdProvider !== 'undefined') {
      toReturn['externalIdProvider'] = this.externalIdProvider;
    }
    if (typeof this.internalId !== 'undefined') {
      toReturn['internalId'] = this.internalId;
    }
    if (typeof this.externalId !== 'undefined') {
      toReturn['externalId'] = this.externalId;
    }
    return toReturn;
  }
}
class ExternalIdentifierGetByInternalIDRequest {
  static fromProto(proto) {
    let m = new ExternalIdentifierGetByInternalIDRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.externalIdProvider !== 'undefined') {
      toReturn['externalIdProvider'] = this.externalIdProvider;
    }
    if (typeof this.internalId !== 'undefined') {
      toReturn['internalId'] = this.internalId;
    }
    return toReturn;
  }
}
class ExternalIdentifierGetByInternalIDResponse {
  static fromProto(proto) {
    let m = new ExternalIdentifierGetByInternalIDResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.externalId !== 'undefined') {
      toReturn['externalId'] = this.externalId;
    }
    return toReturn;
  }
}
class GetAssignedSalespersonForPartnerRequest {
  static fromProto(proto) {
    let m = new GetAssignedSalespersonForPartnerRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    return toReturn;
  }
}
class GetAssignedSalespersonForPartnerResponse {
  static fromProto(proto) {
    let m = new GetAssignedSalespersonForPartnerResponse();
    m = Object.assign(m, proto);
    if (proto.salesperson) {
      m.salesperson = Salesperson.fromProto(proto.salesperson);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.salesperson !== 'undefined' && this.salesperson !== null) {
      toReturn['salesperson'] = 'toApiJson' in this.salesperson ? this.salesperson.toApiJson() : this.salesperson;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class GetAutoAssignConfigRequest {
  static fromProto(proto) {
    let m = new GetAutoAssignConfigRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    return toReturn;
  }
}
class GetAutoAssignConfigResponse {
  static fromProto(proto) {
    let m = new GetAutoAssignConfigResponse();
    m = Object.assign(m, proto);
    if (proto.rules) {
      m.rules = proto.rules.map(AutoAssignRule.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.rules !== 'undefined' && this.rules !== null) {
      toReturn['rules'] = 'toApiJson' in this.rules ? this.rules.toApiJson() : this.rules;
    }
    return toReturn;
  }
}
class GetConfigurationRequest {
  static fromProto(proto) {
    let m = new GetConfigurationRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class GetConfigurationResponse {
  static fromProto(proto) {
    let m = new GetConfigurationResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.domain !== 'undefined') {
      toReturn['domain'] = this.domain;
    }
    if (typeof this.isValid !== 'undefined') {
      toReturn['isValid'] = this.isValid;
    }
    return toReturn;
  }
}
class GetContactsByEmailRequest {
  static fromProto(proto) {
    let m = new GetContactsByEmailRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    return toReturn;
  }
}
class GetContactsResponse {
  static fromProto(proto) {
    let m = new GetContactsResponse();
    m = Object.assign(m, proto);
    if (proto.contacts) {
      m.contacts = proto.contacts.map(Contact.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.contacts !== 'undefined' && this.contacts !== null) {
      toReturn['contacts'] = 'toApiJson' in this.contacts ? this.contacts.toApiJson() : this.contacts;
    }
    return toReturn;
  }
}
class GetMembersRequest {
  static fromProto(proto) {
    let m = new GetMembersRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.groupId !== 'undefined') {
      toReturn['groupId'] = this.groupId;
    }
    return toReturn;
  }
}
class GetMembersResponse {
  static fromProto(proto) {
    let m = new GetMembersResponse();
    m = Object.assign(m, proto);
    if (proto.salesPeople) {
      m.salesPeople = proto.salesPeople.map(Salesperson.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.salesPeople !== 'undefined' && this.salesPeople !== null) {
      toReturn['salesPeople'] = 'toApiJson' in this.salesPeople ? this.salesPeople.toApiJson() : this.salesPeople;
    }
    return toReturn;
  }
}
class GetMultiCampaignsRequest {
  static fromProto(proto) {
    let m = new GetMultiCampaignsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.campaignIds !== 'undefined') {
      toReturn['campaignIds'] = this.campaignIds;
    }
    return toReturn;
  }
}
class GetMultiCampaignsResponse {
  static fromProto(proto) {
    let m = new GetMultiCampaignsResponse();
    m = Object.assign(m, proto);
    if (proto.campaigns) {
      m.campaigns = proto.campaigns.map(SalesCampaign.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.campaigns !== 'undefined' && this.campaigns !== null) {
      toReturn['campaigns'] = 'toApiJson' in this.campaigns ? this.campaigns.toApiJson() : this.campaigns;
    }
    return toReturn;
  }
}
class GetMultiSalesActivityRequest {
  static fromProto(proto) {
    let m = new GetMultiSalesActivityRequest();
    m = Object.assign(m, proto);
    if (proto.keys) {
      m.keys = proto.keys.map(SalesActivityKey.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.keys !== 'undefined' && this.keys !== null) {
      toReturn['keys'] = 'toApiJson' in this.keys ? this.keys.toApiJson() : this.keys;
    }
    return toReturn;
  }
}
class GetMultiSalesActivityResponse {
  static fromProto(proto) {
    let m = new GetMultiSalesActivityResponse();
    m = Object.assign(m, proto);
    if (proto.salesActivities) {
      m.salesActivities = proto.salesActivities.map(GetMultiSalesActivityResponseSalesActivityContainer.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.salesActivities !== 'undefined' && this.salesActivities !== null) {
      toReturn['salesActivities'] = 'toApiJson' in this.salesActivities ? this.salesActivities.toApiJson() : this.salesActivities;
    }
    return toReturn;
  }
}
class GetMultiSalesTeamRequest {
  static fromProto(proto) {
    let m = new GetMultiSalesTeamRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.groupIds !== 'undefined') {
      toReturn['groupIds'] = this.groupIds;
    }
    return toReturn;
  }
}
class GetMultiSalesTeamResponse {
  static fromProto(proto) {
    let m = new GetMultiSalesTeamResponse();
    m = Object.assign(m, proto);
    if (proto.salesTeams) {
      m.salesTeams = proto.salesTeams.map(SalesTeam.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.salesTeams !== 'undefined' && this.salesTeams !== null) {
      toReturn['salesTeams'] = 'toApiJson' in this.salesTeams ? this.salesTeams.toApiJson() : this.salesTeams;
    }
    return toReturn;
  }
}
class GetMultiSalespersonRequest {
  static fromProto(proto) {
    let m = new GetMultiSalespersonRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.salespersonIds !== 'undefined') {
      toReturn['salespersonIds'] = this.salespersonIds;
    }
    return toReturn;
  }
}
class GetMultiSalespersonResponse {
  static fromProto(proto) {
    let m = new GetMultiSalespersonResponse();
    m = Object.assign(m, proto);
    if (proto.salespersons) {
      m.salespersons = proto.salespersons.map(Salesperson.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.salespersons !== 'undefined' && this.salespersons !== null) {
      toReturn['salespersons'] = 'toApiJson' in this.salespersons ? this.salespersons.toApiJson() : this.salespersons;
    }
    return toReturn;
  }
}
class GetSalespersonRequest {
  static fromProto(proto) {
    let m = new GetSalespersonRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.salespersonId !== 'undefined') {
      toReturn['salespersonId'] = this.salespersonId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    return toReturn;
  }
}
class GetTeamsBySalespersonsRequest {
  static fromProto(proto) {
    let m = new GetTeamsBySalespersonsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.salespersonIds !== 'undefined') {
      toReturn['salespersonIds'] = this.salespersonIds;
    }
    return toReturn;
  }
}
class GetTeamsBySalespersonsResponse {
  static fromProto(proto) {
    let m = new GetTeamsBySalespersonsResponse();
    m = Object.assign(m, proto);
    if (proto.teamMapping) {
      m.teamMapping = proto.teamMapping.map(GetTeamsBySalespersonsResponseTeamsForSalesperson.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.teamMapping !== 'undefined' && this.teamMapping !== null) {
      toReturn['teamMapping'] = 'toApiJson' in this.teamMapping ? this.teamMapping.toApiJson() : this.teamMapping;
    }
    return toReturn;
  }
}
class GetZoomMeetingInfoRequest {
  static fromProto(proto) {
    let m = new GetZoomMeetingInfoRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.meetingId !== 'undefined') {
      toReturn['meetingId'] = this.meetingId;
    }
    return toReturn;
  }
}
class GetZoomMeetingInfoResponse {
  static fromProto(proto) {
    let m = new GetZoomMeetingInfoResponse();
    m = Object.assign(m, proto);
    if (proto.zoomMeeting) {
      m.zoomMeeting = ZoomMeeting.fromProto(proto.zoomMeeting);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.zoomMeeting !== 'undefined' && this.zoomMeeting !== null) {
      toReturn['zoomMeeting'] = 'toApiJson' in this.zoomMeeting ? this.zoomMeeting.toApiJson() : this.zoomMeeting;
    }
    return toReturn;
  }
}
class ListSalesTeamsRequestListSalesTeamsFilters {
  static fromProto(proto) {
    let m = new ListSalesTeamsRequestListSalesTeamsFilters();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    return toReturn;
  }
}
class ListSalesTeamsRequest {
  static fromProto(proto) {
    let m = new ListSalesTeamsRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListSalesTeamsRequestListSalesTeamsFilters.fromProto(proto.filters);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListSalesTeamsResponse {
  static fromProto(proto) {
    let m = new ListSalesTeamsResponse();
    m = Object.assign(m, proto);
    if (proto.salesTeams) {
      m.salesTeams = proto.salesTeams.map(SalesTeam.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.salesTeams !== 'undefined' && this.salesTeams !== null) {
      toReturn['salesTeams'] = 'toApiJson' in this.salesTeams ? this.salesTeams.toApiJson() : this.salesTeams;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ListSalespersonsRequestListSalespersonsFilters {
  static fromProto(proto) {
    let m = new ListSalespersonsRequestListSalespersonsFilters();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.onlySalesManagers !== 'undefined') {
      toReturn['onlySalesManagers'] = this.onlySalesManagers;
    }
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    return toReturn;
  }
}
class ListSalespersonsRequest {
  static fromProto(proto) {
    let m = new ListSalespersonsRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListSalespersonsRequestListSalespersonsFilters.fromProto(proto.filters);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListSalespersonsResponse {
  static fromProto(proto) {
    let m = new ListSalespersonsResponse();
    m = Object.assign(m, proto);
    if (proto.salespersons) {
      m.salespersons = proto.salespersons.map(Salesperson.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.salespersons !== 'undefined' && this.salespersons !== null) {
      toReturn['salespersons'] = 'toApiJson' in this.salespersons ? this.salespersons.toApiJson() : this.salespersons;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class AutoAssignCriteriaLocationCriteria {
  static fromProto(proto) {
    let m = new AutoAssignCriteriaLocationCriteria();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.country !== 'undefined') {
      toReturn['country'] = this.country;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.city !== 'undefined') {
      toReturn['city'] = this.city;
    }
    return toReturn;
  }
}
class LookupCampaignsRequest {
  static fromProto(proto) {
    let m = new LookupCampaignsRequest();
    m = Object.assign(m, proto);
    if (proto.offset) {
      m.offset = parseInt(proto.offset, 10);
    }
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.focus !== 'undefined') {
      toReturn['focus'] = this.focus;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.offset !== 'undefined') {
      toReturn['offset'] = this.offset;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    return toReturn;
  }
}
class LookupCampaignsResponse {
  static fromProto(proto) {
    let m = new LookupCampaignsResponse();
    m = Object.assign(m, proto);
    if (proto.campaigns) {
      m.campaigns = proto.campaigns.map(SalesCampaign.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.campaigns !== 'undefined' && this.campaigns !== null) {
      toReturn['campaigns'] = 'toApiJson' in this.campaigns ? this.campaigns.toApiJson() : this.campaigns;
    }
    return toReturn;
  }
}
class LookupSalespersonsRequest {
  static fromProto(proto) {
    let m = new LookupSalespersonsRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    if (typeof this.marketIds !== 'undefined') {
      toReturn['marketIds'] = this.marketIds;
    }
    if (typeof this.includeLastLogin !== 'undefined') {
      toReturn['includeLastLogin'] = this.includeLastLogin;
    }
    return toReturn;
  }
}
class LookupSalespersonsResponse {
  static fromProto(proto) {
    let m = new LookupSalespersonsResponse();
    m = Object.assign(m, proto);
    if (proto.salespersons) {
      m.salespersons = proto.salespersons.map(Salesperson.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.salespersons !== 'undefined' && this.salespersons !== null) {
      toReturn['salespersons'] = 'toApiJson' in this.salespersons ? this.salespersons.toApiJson() : this.salespersons;
    }
    return toReturn;
  }
}
class PagedRequestOptions {
  static fromProto(proto) {
    let m = new PagedRequestOptions();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class PagedResponseMetadata {
  static fromProto(proto) {
    let m = new PagedResponseMetadata();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class PartnerSalesDomainRequest {
  static fromProto(proto) {
    let m = new PartnerSalesDomainRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class PartnerSalesDomainResponse {
  static fromProto(proto) {
    let m = new PartnerSalesDomainResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.domain !== 'undefined') {
      toReturn['domain'] = this.domain;
    }
    return toReturn;
  }
}
class PublishAskQuestionEventRequest {
  static fromProto(proto) {
    let m = new PublishAskQuestionEventRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.vbcUserId !== 'undefined') {
      toReturn['vbcUserId'] = this.vbcUserId;
    }
    return toReturn;
  }
}
class PublishClaimAccountEventRequest {
  static fromProto(proto) {
    let m = new PublishClaimAccountEventRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.userEmail !== 'undefined') {
      toReturn['userEmail'] = this.userEmail;
    }
    return toReturn;
  }
}
class PublishPackageInterestEventRequest {
  static fromProto(proto) {
    let m = new PublishPackageInterestEventRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.packageId !== 'undefined') {
      toReturn['packageId'] = this.packageId;
    }
    if (typeof this.vbcUserId !== 'undefined') {
      toReturn['vbcUserId'] = this.vbcUserId;
    }
    if (typeof this.userEmail !== 'undefined') {
      toReturn['userEmail'] = this.userEmail;
    }
    return toReturn;
  }
}
class PublishProductInterestEventRequest {
  static fromProto(proto) {
    let m = new PublishProductInterestEventRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.vbcUserId !== 'undefined') {
      toReturn['vbcUserId'] = this.vbcUserId;
    }
    if (typeof this.productId !== 'undefined') {
      toReturn['productId'] = this.productId;
    }
    if (typeof this.message !== 'undefined') {
      toReturn['message'] = this.message;
    }
    if (typeof this.userEmail !== 'undefined') {
      toReturn['userEmail'] = this.userEmail;
    }
    return toReturn;
  }
}
class PublishSnapshotOpenEventRequest {
  static fromProto(proto) {
    let m = new PublishSnapshotOpenEventRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.snapshotId !== 'undefined') {
      toReturn['snapshotId'] = this.snapshotId;
    }
    return toReturn;
  }
}
class AddContactToCampaignRequestRecipient {
  static fromProto(proto) {
    let m = new AddContactToCampaignRequestRecipient();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.emailAddress !== 'undefined') {
      toReturn['emailAddress'] = this.emailAddress;
    }
    return toReturn;
  }
}
class RequestSubscriptionChangeRequest {
  static fromProto(proto) {
    let m = new RequestSubscriptionChangeRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.message !== 'undefined') {
      toReturn['message'] = this.message;
    }
    if (typeof this.phoneNumber !== 'undefined') {
      toReturn['phoneNumber'] = this.phoneNumber;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    return toReturn;
  }
}
class GetMultiSalesActivityResponseSalesActivityContainer {
  static fromProto(proto) {
    let m = new GetMultiSalesActivityResponseSalesActivityContainer();
    m = Object.assign(m, proto);
    if (proto.salesActivity) {
      m.salesActivity = SalesActivity.fromProto(proto.salesActivity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.salesActivity !== 'undefined' && this.salesActivity !== null) {
      toReturn['salesActivity'] = 'toApiJson' in this.salesActivity ? this.salesActivity.toApiJson() : this.salesActivity;
    }
    return toReturn;
  }
}
class SalesCampaign {
  static fromProto(proto) {
    let m = new SalesCampaign();
    m = Object.assign(m, proto);
    if (proto.campaignSchedule) {
      m.campaignSchedule = proto.campaignSchedule.map(ScheduleStep.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.campaignStatus !== 'undefined') {
      toReturn['campaignStatus'] = this.campaignStatus;
    }
    if (typeof this.campaignId !== 'undefined') {
      toReturn['campaignId'] = this.campaignId;
    }
    if (typeof this.campaignSchedule !== 'undefined' && this.campaignSchedule !== null) {
      toReturn['campaignSchedule'] = 'toApiJson' in this.campaignSchedule ? this.campaignSchedule.toApiJson() : this.campaignSchedule;
    }
    return toReturn;
  }
}
class BusinessListResponseSalestoolBusiness {
  static fromProto(proto) {
    let m = new BusinessListResponseSalestoolBusiness();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.address !== 'undefined') {
      toReturn['address'] = this.address;
    }
    if (typeof this.city !== 'undefined') {
      toReturn['city'] = this.city;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.zip !== 'undefined') {
      toReturn['zip'] = this.zip;
    }
    if (typeof this.country !== 'undefined') {
      toReturn['country'] = this.country;
    }
    if (typeof this.contactFirstName !== 'undefined') {
      toReturn['contactFirstName'] = this.contactFirstName;
    }
    if (typeof this.contactLastName !== 'undefined') {
      toReturn['contactLastName'] = this.contactLastName;
    }
    if (typeof this.contactEmail !== 'undefined') {
      toReturn['contactEmail'] = this.contactEmail;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    return toReturn;
  }
}
class ScheduleStep {
  static fromProto(proto) {
    let m = new ScheduleStep();
    m = Object.assign(m, proto);
    if (proto.secondsAfterLastEmail) {
      m.secondsAfterLastEmail = parseInt(proto.secondsAfterLastEmail, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.stepType !== 'undefined') {
      toReturn['stepType'] = this.stepType;
    }
    if (typeof this.secondsAfterLastEmail !== 'undefined') {
      toReturn['secondsAfterLastEmail'] = this.secondsAfterLastEmail;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.templateId !== 'undefined') {
      toReturn['templateId'] = this.templateId;
    }
    return toReturn;
  }
}
class SearchTicketsRequest {
  static fromProto(proto) {
    let m = new SearchTicketsRequest();
    m = Object.assign(m, proto);
    if (proto.pagination) {
      m.pagination = Pagination.fromProto(proto.pagination);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.pagination !== 'undefined' && this.pagination !== null) {
      toReturn['pagination'] = 'toApiJson' in this.pagination ? this.pagination.toApiJson() : this.pagination;
    }
    return toReturn;
  }
}
class SearchTicketsResponse {
  static fromProto(proto) {
    let m = new SearchTicketsResponse();
    m = Object.assign(m, proto);
    if (proto.tickets) {
      m.tickets = proto.tickets.map(Ticket.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.tickets !== 'undefined' && this.tickets !== null) {
      toReturn['tickets'] = 'toApiJson' in this.tickets ? this.tickets.toApiJson() : this.tickets;
    }
    return toReturn;
  }
}
class SendResetPasswordEmailRequest {
  static fromProto(proto) {
    let m = new SendResetPasswordEmailRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.salespersonId !== 'undefined') {
      toReturn['salespersonId'] = this.salespersonId;
    }
    return toReturn;
  }
}
class AddContactToCampaignRequestSender {
  static fromProto(proto) {
    let m = new AddContactToCampaignRequestSender();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.emailAddress !== 'undefined') {
      toReturn['emailAddress'] = this.emailAddress;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.salespersonId !== 'undefined') {
      toReturn['salespersonId'] = this.salespersonId;
    }
    return toReturn;
  }
}
class SetConfigurationRequest {
  static fromProto(proto) {
    let m = new SetConfigurationRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.domain !== 'undefined') {
      toReturn['domain'] = this.domain;
    }
    if (typeof this.apiKey !== 'undefined') {
      toReturn['apiKey'] = this.apiKey;
    }
    return toReturn;
  }
}
class StoreZoomMeetingInfoRequest {
  static fromProto(proto) {
    let m = new StoreZoomMeetingInfoRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.meetingId !== 'undefined') {
      toReturn['meetingId'] = this.meetingId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.salesPersonId !== 'undefined') {
      toReturn['salesPersonId'] = this.salesPersonId;
    }
    return toReturn;
  }
}
class AutoAssignCriteriaTagCriteria {
  static fromProto(proto) {
    let m = new AutoAssignCriteriaTagCriteria();
    m = Object.assign(m, proto);
    if (proto.matchType) {
      m.matchType = enumStringToValue$2(TagMatchType, proto.matchType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.matchType !== 'undefined') {
      toReturn['matchType'] = this.matchType;
    }
    return toReturn;
  }
}
class GetTeamsBySalespersonsResponseTeamsForSalesperson {
  static fromProto(proto) {
    let m = new GetTeamsBySalespersonsResponseTeamsForSalesperson();
    m = Object.assign(m, proto);
    if (proto.salesTeams) {
      m.salesTeams = proto.salesTeams.map(SalesTeam.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.salespersonId !== 'undefined') {
      toReturn['salespersonId'] = this.salespersonId;
    }
    if (typeof this.salesTeams !== 'undefined' && this.salesTeams !== null) {
      toReturn['salesTeams'] = 'toApiJson' in this.salesTeams ? this.salesTeams.toApiJson() : this.salesTeams;
    }
    return toReturn;
  }
}
class UpdatePartnerSalesDomainRequest {
  static fromProto(proto) {
    let m = new UpdatePartnerSalesDomainRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.domain !== 'undefined') {
      toReturn['domain'] = this.domain;
    }
    return toReturn;
  }
}
class UpdateTeamNameRequest {
  static fromProto(proto) {
    let m = new UpdateTeamNameRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.groupId !== 'undefined') {
      toReturn['groupId'] = this.groupId;
    }
    if (typeof this.newTeamName !== 'undefined') {
      toReturn['newTeamName'] = this.newTeamName;
    }
    return toReturn;
  }
}
class ViewTicketIncludeFields {
  static fromProto(proto) {
    let m = new ViewTicketIncludeFields();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.conversations !== 'undefined') {
      toReturn['conversations'] = this.conversations;
    }
    if (typeof this.requester !== 'undefined') {
      toReturn['requester'] = this.requester;
    }
    if (typeof this.company !== 'undefined') {
      toReturn['company'] = this.company;
    }
    if (typeof this.stats !== 'undefined') {
      toReturn['stats'] = this.stats;
    }
    return toReturn;
  }
}
class ViewTicketRequest {
  static fromProto(proto) {
    let m = new ViewTicketRequest();
    m = Object.assign(m, proto);
    if (proto.ticketId) {
      m.ticketId = parseInt(proto.ticketId, 10);
    }
    if (proto.includeFields) {
      m.includeFields = ViewTicketIncludeFields.fromProto(proto.includeFields);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.ticketId !== 'undefined') {
      toReturn['ticketId'] = this.ticketId;
    }
    if (typeof this.includeFields !== 'undefined' && this.includeFields !== null) {
      toReturn['includeFields'] = 'toApiJson' in this.includeFields ? this.includeFields.toApiJson() : this.includeFields;
    }
    return toReturn;
  }
}
class ViewTicketResponse {
  static fromProto(proto) {
    let m = new ViewTicketResponse();
    m = Object.assign(m, proto);
    if (proto.baseTicket) {
      m.baseTicket = Ticket.fromProto(proto.baseTicket);
    }
    if (proto.conversations) {
      m.conversations = proto.conversations.map(Conversation.fromProto);
    }
    if (proto.priority) {
      m.priority = enumStringToValue$2(TicketPriority, proto.priority);
    }
    if (proto.dueBy) {
      m.dueBy = new Date(proto.dueBy);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.baseTicket !== 'undefined' && this.baseTicket !== null) {
      toReturn['baseTicket'] = 'toApiJson' in this.baseTicket ? this.baseTicket.toApiJson() : this.baseTicket;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.conversations !== 'undefined' && this.conversations !== null) {
      toReturn['conversations'] = 'toApiJson' in this.conversations ? this.conversations.toApiJson() : this.conversations;
    }
    if (typeof this.priority !== 'undefined') {
      toReturn['priority'] = this.priority;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.dueBy !== 'undefined' && this.dueBy !== null) {
      toReturn['dueBy'] = 'toApiJson' in this.dueBy ? this.dueBy.toApiJson() : this.dueBy;
    }
    return toReturn;
  }
}
class ZoomMeeting {
  static fromProto(proto) {
    let m = new ZoomMeeting();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.meetingId !== 'undefined') {
      toReturn['meetingId'] = this.meetingId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.salesPersonId !== 'undefined') {
      toReturn['salesPersonId'] = this.salesPersonId;
    }
    return toReturn;
  }
}
function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class PriceComponent {
  static fromProto(proto) {
    let m = new PriceComponent();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = parseInt(proto.value, 10);
    }
    if (proto.frequency) {
      m.frequency = enumStringToValue$1(Frequency, proto.frequency);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    if (typeof this.frequency !== 'undefined') {
      toReturn['frequency'] = this.frequency;
    }
    return toReturn;
  }
}
function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class LineItemAppKey {
  static fromProto(proto) {
    let m = new LineItemAppKey();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.editionId !== 'undefined') {
      toReturn['editionId'] = this.editionId;
    }
    if (typeof this.packageId !== 'undefined') {
      toReturn['packageId'] = this.packageId;
    }
    if (typeof this.packageInstanceId !== 'undefined') {
      toReturn['packageInstanceId'] = this.packageInstanceId;
    }
    return toReturn;
  }
}
class BillingPeriod {
  static fromProto(proto) {
    let m = new BillingPeriod();
    m = Object.assign(m, proto);
    if (proto.startDate) {
      m.startDate = new Date(proto.startDate);
    }
    if (proto.endDate) {
      m.endDate = new Date(proto.endDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.startDate !== 'undefined' && this.startDate !== null) {
      toReturn['startDate'] = 'toApiJson' in this.startDate ? this.startDate.toApiJson() : this.startDate;
    }
    if (typeof this.endDate !== 'undefined' && this.endDate !== null) {
      toReturn['endDate'] = 'toApiJson' in this.endDate ? this.endDate.toApiJson() : this.endDate;
    }
    return toReturn;
  }
}
class Cost {
  static fromProto(proto) {
    let m = new Cost();
    m = Object.assign(m, proto);
    if (proto.customPrice) {
      m.customPrice = parseInt(proto.customPrice, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.customPrice !== 'undefined') {
      toReturn['customPrice'] = this.customPrice;
    }
    return toReturn;
  }
}
class CustomPriceMapping {
  static fromProto(proto) {
    let m = new CustomPriceMapping();
    m = Object.assign(m, proto);
    if (proto.customPrice) {
      m.customPrice = parseInt(proto.customPrice, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.productId !== 'undefined') {
      toReturn['productId'] = this.productId;
    }
    if (typeof this.customPrice !== 'undefined') {
      toReturn['customPrice'] = this.customPrice;
    }
    return toReturn;
  }
}
class Duration {
  static fromProto(proto) {
    let m = new Duration();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = parseInt(proto.value, 10);
    }
    if (proto.duration) {
      m.duration = enumStringToValue(DurationPeriod, proto.duration);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    if (typeof this.duration !== 'undefined') {
      toReturn['duration'] = this.duration;
    }
    return toReturn;
  }
}
class LineItem {
  static fromProto(proto) {
    let m = new LineItem();
    m = Object.assign(m, proto);
    if (proto.appKey) {
      m.appKey = LineItemAppKey.fromProto(proto.appKey);
    }
    if (proto.currency) {
      m.currency = enumStringToValue(Currency, proto.currency);
    }
    if (proto.initialRevenue) {
      m.initialRevenue = Revenue.fromProto(proto.initialRevenue);
    }
    if (proto.currentRevenue) {
      m.currentRevenue = Revenue.fromProto(proto.currentRevenue);
    }
    if (proto.quantity) {
      m.quantity = parseInt(proto.quantity, 10);
    }
    if (proto.cost) {
      m.cost = Cost.fromProto(proto.cost);
    }
    if (proto.customPrices) {
      m.customPrices = proto.customPrices.map(CustomPriceMapping.fromProto);
    }
    if (proto.billingPeriod) {
      m.billingPeriod = BillingPeriod.fromProto(proto.billingPeriod);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appKey !== 'undefined' && this.appKey !== null) {
      toReturn['appKey'] = 'toApiJson' in this.appKey ? this.appKey.toApiJson() : this.appKey;
    }
    if (typeof this.packageId !== 'undefined') {
      toReturn['packageId'] = this.packageId;
    }
    if (typeof this.currency !== 'undefined') {
      toReturn['currency'] = this.currency;
    }
    if (typeof this.initialRevenue !== 'undefined' && this.initialRevenue !== null) {
      toReturn['initialRevenue'] = 'toApiJson' in this.initialRevenue ? this.initialRevenue.toApiJson() : this.initialRevenue;
    }
    if (typeof this.currentRevenue !== 'undefined' && this.currentRevenue !== null) {
      toReturn['currentRevenue'] = 'toApiJson' in this.currentRevenue ? this.currentRevenue.toApiJson() : this.currentRevenue;
    }
    if (typeof this.quantity !== 'undefined') {
      toReturn['quantity'] = this.quantity;
    }
    if (typeof this.isTrial !== 'undefined') {
      toReturn['isTrial'] = this.isTrial;
    }
    if (typeof this.currencyCode !== 'undefined') {
      toReturn['currencyCode'] = this.currencyCode;
    }
    if (typeof this.cost !== 'undefined' && this.cost !== null) {
      toReturn['cost'] = 'toApiJson' in this.cost ? this.cost.toApiJson() : this.cost;
    }
    if (typeof this.customPrices !== 'undefined' && this.customPrices !== null) {
      toReturn['customPrices'] = 'toApiJson' in this.customPrices ? this.customPrices.toApiJson() : this.customPrices;
    }
    if (typeof this.billingPeriod !== 'undefined' && this.billingPeriod !== null) {
      toReturn['billingPeriod'] = 'toApiJson' in this.billingPeriod ? this.billingPeriod.toApiJson() : this.billingPeriod;
    }
    if (typeof this.autoBillable !== 'undefined') {
      toReturn['autoBillable'] = this.autoBillable;
    }
    if (typeof this.nonBillable !== 'undefined') {
      toReturn['nonBillable'] = this.nonBillable;
    }
    return toReturn;
  }
}
class Revenue {
  static fromProto(proto) {
    let m = new Revenue();
    m = Object.assign(m, proto);
    if (proto.revenueComponents) {
      m.revenueComponents = proto.revenueComponents.map(RevenueComponent.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.revenueComponents !== 'undefined' && this.revenueComponents !== null) {
      toReturn['revenueComponents'] = 'toApiJson' in this.revenueComponents ? this.revenueComponents.toApiJson() : this.revenueComponents;
    }
    return toReturn;
  }
}
class RevenueComponent {
  static fromProto(proto) {
    let m = new RevenueComponent();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = parseInt(proto.value, 10);
    }
    if (proto.period) {
      m.period = enumStringToValue(RevenuePeriod, proto.period);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    if (typeof this.period !== 'undefined') {
      toReturn['period'] = this.period;
    }
    if (typeof this.isStartingRevenue !== 'undefined') {
      toReturn['isStartingRevenue'] = this.isStartingRevenue;
    }
    return toReturn;
  }
}

// *********************************

const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'sales-api.vendasta-local.com',
  'test': '',
  'demo': 'sales-api-demo.apigateway.co',
  'prod': 'sales-api-prod.apigateway.co',
  'production': 'sales-api-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(t) {
    return new (t || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let BusinessActivityApiService = /*#__PURE__*/(() => {
  class BusinessActivityApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createBusinessActivity(r) {
      const request = r.toApiJson ? r : new CreateBusinessActivityRequest(r);
      return this.http.post(this._host + "/sales.v1.BusinessActivity/CreateBusinessActivity", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  BusinessActivityApiService.ɵfac = function BusinessActivityApiService_Factory(t) {
    return new (t || BusinessActivityApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  BusinessActivityApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: BusinessActivityApiService,
    factory: BusinessActivityApiService.ɵfac,
    providedIn: 'root'
  });
  return BusinessActivityApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let BusinessApiService = /*#__PURE__*/(() => {
  class BusinessApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    search(r) {
      const request = r.toApiJson ? r : new BusinessSearchRequest(r);
      return this.http.post(this._host + "/sales.v1.BusinessService/Search", request.toApiJson(), this.apiOptions()).pipe(map(resp => BusinessSearchResponse.fromProto(resp)));
    }
    requestSubscriptionChange(r) {
      const request = r.toApiJson ? r : new RequestSubscriptionChangeRequest(r);
      return this.http.post(this._host + "/sales.v1.BusinessService/RequestSubscriptionChange", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    list(r) {
      const request = r.toApiJson ? r : new BusinessListRequest(r);
      return this.http.post(this._host + "/sales.v1.BusinessService/List", request.toApiJson(), this.apiOptions()).pipe(map(resp => BusinessListResponse.fromProto(resp)));
    }
  }
  BusinessApiService.ɵfac = function BusinessApiService_Factory(t) {
    return new (t || BusinessApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  BusinessApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: BusinessApiService,
    factory: BusinessApiService.ɵfac,
    providedIn: 'root'
  });
  return BusinessApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let CampaignApiService = /*#__PURE__*/(() => {
  class CampaignApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getMultiCampaigns(r) {
      const request = r.toApiJson ? r : new GetMultiCampaignsRequest(r);
      return this.http.post(this._host + "/sales.v1.CampaignService/GetMultiCampaigns", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiCampaignsResponse.fromProto(resp)));
    }
    lookupCampaigns(r) {
      const request = r.toApiJson ? r : new LookupCampaignsRequest(r);
      return this.http.post(this._host + "/sales.v1.CampaignService/LookupCampaigns", request.toApiJson(), this.apiOptions()).pipe(map(resp => LookupCampaignsResponse.fromProto(resp)));
    }
    addContactToCampaign(r) {
      const request = r.toApiJson ? r : new AddContactToCampaignRequest(r);
      return this.http.post(this._host + "/sales.v1.CampaignService/AddContactToCampaign", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  CampaignApiService.ɵfac = function CampaignApiService_Factory(t) {
    return new (t || CampaignApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  CampaignApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CampaignApiService,
    factory: CampaignApiService.ɵfac,
    providedIn: 'root'
  });
  return CampaignApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let ContactsApiService = /*#__PURE__*/(() => {
  class ContactsApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    create(r) {
      const request = r.toApiJson ? r : new ContactCreateRequest(r);
      return this.http.post(this._host + "/sales.v1.Contacts/Create", request.toApiJson(), this.apiOptions()).pipe(map(resp => ContactCreateResponse.fromProto(resp)));
    }
    getContactsByEmail(r) {
      const request = r.toApiJson ? r : new GetContactsByEmailRequest(r);
      return this.http.post(this._host + "/sales.v1.Contacts/GetContactsByEmail", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetContactsResponse.fromProto(resp)));
    }
  }
  ContactsApiService.ɵfac = function ContactsApiService_Factory(t) {
    return new (t || ContactsApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  ContactsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ContactsApiService,
    factory: ContactsApiService.ɵfac,
    providedIn: 'root'
  });
  return ContactsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let ExternalIdentifiersApiService = /*#__PURE__*/(() => {
  class ExternalIdentifiersApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    create(r) {
      const request = r.toApiJson ? r : new ExternalIdentifierCreateRequest(r);
      return this.http.post(this._host + "/sales.v1.ExternalIdentifiers/Create", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getByInternalId(r) {
      const request = r.toApiJson ? r : new ExternalIdentifierGetByInternalIDRequest(r);
      return this.http.post(this._host + "/sales.v1.ExternalIdentifiers/GetByInternalID", request.toApiJson(), this.apiOptions()).pipe(map(resp => ExternalIdentifierGetByInternalIDResponse.fromProto(resp)));
    }
  }
  ExternalIdentifiersApiService.ɵfac = function ExternalIdentifiersApiService_Factory(t) {
    return new (t || ExternalIdentifiersApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  ExternalIdentifiersApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ExternalIdentifiersApiService,
    factory: ExternalIdentifiersApiService.ɵfac,
    providedIn: 'root'
  });
  return ExternalIdentifiersApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let FreshdeskApiService = /*#__PURE__*/(() => {
  class FreshdeskApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    setConfiguration(r) {
      const request = r.toApiJson ? r : new SetConfigurationRequest(r);
      return this.http.post(this._host + "/sales.v1.Freshdesk/SetConfiguration", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getConfiguration(r) {
      const request = r.toApiJson ? r : new GetConfigurationRequest(r);
      return this.http.post(this._host + "/sales.v1.Freshdesk/GetConfiguration", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetConfigurationResponse.fromProto(resp)));
    }
    searchTickets(r) {
      const request = r.toApiJson ? r : new SearchTicketsRequest(r);
      return this.http.post(this._host + "/sales.v1.Freshdesk/SearchTickets", request.toApiJson(), this.apiOptions()).pipe(map(resp => SearchTicketsResponse.fromProto(resp)));
    }
    viewTicket(r) {
      const request = r.toApiJson ? r : new ViewTicketRequest(r);
      return this.http.post(this._host + "/sales.v1.Freshdesk/ViewTicket", request.toApiJson(), this.apiOptions()).pipe(map(resp => ViewTicketResponse.fromProto(resp)));
    }
  }
  FreshdeskApiService.ɵfac = function FreshdeskApiService_Factory(t) {
    return new (t || FreshdeskApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  FreshdeskApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: FreshdeskApiService,
    factory: FreshdeskApiService.ɵfac,
    providedIn: 'root'
  });
  return FreshdeskApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let LegacyEventsApiService = /*#__PURE__*/(() => {
  class LegacyEventsApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    publishSnapshotOpenEvent(r) {
      const request = r.toApiJson ? r : new PublishSnapshotOpenEventRequest(r);
      return this.http.post(this._host + "/sales.v1.LegacyEvents/PublishSnapshotOpenEvent", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    publishAskQuestionEvent(r) {
      const request = r.toApiJson ? r : new PublishAskQuestionEventRequest(r);
      return this.http.post(this._host + "/sales.v1.LegacyEvents/PublishAskQuestionEvent", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    publishClaimAccountEvent(r) {
      const request = r.toApiJson ? r : new PublishClaimAccountEventRequest(r);
      return this.http.post(this._host + "/sales.v1.LegacyEvents/PublishClaimAccountEvent", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    publishProductInterestEvent(r) {
      const request = r.toApiJson ? r : new PublishProductInterestEventRequest(r);
      return this.http.post(this._host + "/sales.v1.LegacyEvents/PublishProductInterestEvent", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    publishPackageInterestEvent(r) {
      const request = r.toApiJson ? r : new PublishPackageInterestEventRequest(r);
      return this.http.post(this._host + "/sales.v1.LegacyEvents/PublishPackageInterestEvent", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  LegacyEventsApiService.ɵfac = function LegacyEventsApiService_Factory(t) {
    return new (t || LegacyEventsApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  LegacyEventsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: LegacyEventsApiService,
    factory: LegacyEventsApiService.ɵfac,
    providedIn: 'root'
  });
  return LegacyEventsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let MeetingApiService = /*#__PURE__*/(() => {
  class MeetingApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    storeZoomMeetingInfo(r) {
      const request = r.toApiJson ? r : new StoreZoomMeetingInfoRequest(r);
      return this.http.post(this._host + "/sales.v1.Meeting/StoreZoomMeetingInfo", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getZoomMeetingInfo(r) {
      const request = r.toApiJson ? r : new GetZoomMeetingInfoRequest(r);
      return this.http.post(this._host + "/sales.v1.Meeting/GetZoomMeetingInfo", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetZoomMeetingInfoResponse.fromProto(resp)));
    }
  }
  MeetingApiService.ɵfac = function MeetingApiService_Factory(t) {
    return new (t || MeetingApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  MeetingApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: MeetingApiService,
    factory: MeetingApiService.ɵfac,
    providedIn: 'root'
  });
  return MeetingApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let PartnerApiService = /*#__PURE__*/(() => {
  class PartnerApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getPartnerSalesDomain(r) {
      const request = r.toApiJson ? r : new PartnerSalesDomainRequest(r);
      return this.http.post(this._host + "/sales.v1.PartnerService/GetPartnerSalesDomain", request.toApiJson(), this.apiOptions()).pipe(map(resp => PartnerSalesDomainResponse.fromProto(resp)));
    }
    updatePartnerSalesDomain(r) {
      const request = r.toApiJson ? r : new UpdatePartnerSalesDomainRequest(r);
      return this.http.post(this._host + "/sales.v1.PartnerService/UpdatePartnerSalesDomain", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  PartnerApiService.ɵfac = function PartnerApiService_Factory(t) {
    return new (t || PartnerApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  PartnerApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: PartnerApiService,
    factory: PartnerApiService.ɵfac,
    providedIn: 'root'
  });
  return PartnerApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let SalesApiService = /*#__PURE__*/(() => {
  class SalesApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getAutoAssignConfig(r) {
      const request = r.toApiJson ? r : new GetAutoAssignConfigRequest(r);
      return this.http.post(this._host + "/sales.v1.Sales/GetAutoAssignConfig", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetAutoAssignConfigResponse.fromProto(resp)));
    }
    createOrUpdateAutoAssignConfig(r) {
      const request = r.toApiJson ? r : new CreateOrUpdateAutoAssignConfigRequest(r);
      return this.http.post(this._host + "/sales.v1.Sales/CreateOrUpdateAutoAssignConfig", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getSalesperson(r) {
      const request = r.toApiJson ? r : new GetSalespersonRequest(r);
      return this.http.post(this._host + "/sales.v1.Sales/GetSalesperson", request.toApiJson(), this.apiOptions()).pipe(map(resp => Salesperson.fromProto(resp)));
    }
    getMultiSalesperson(r) {
      const request = r.toApiJson ? r : new GetMultiSalespersonRequest(r);
      return this.http.post(this._host + "/sales.v1.Sales/GetMultiSalesperson", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiSalespersonResponse.fromProto(resp)));
    }
    listSalespersons(r) {
      const request = r.toApiJson ? r : new ListSalespersonsRequest(r);
      return this.http.post(this._host + "/sales.v1.Sales/ListSalespersons", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListSalespersonsResponse.fromProto(resp)));
    }
    getAssignedSalespersonForPartner(r) {
      const request = r.toApiJson ? r : new GetAssignedSalespersonForPartnerRequest(r);
      return this.http.post(this._host + "/sales.v1.Sales/GetAssignedSalespersonForPartner", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetAssignedSalespersonForPartnerResponse.fromProto(resp)));
    }
    lookupSalespersons(r) {
      const request = r.toApiJson ? r : new LookupSalespersonsRequest(r);
      return this.http.post(this._host + "/sales.v1.Sales/LookupSalespersons", request.toApiJson(), this.apiOptions()).pipe(map(resp => LookupSalespersonsResponse.fromProto(resp)));
    }
    sendResetPasswordEmail(r) {
      const request = r.toApiJson ? r : new SendResetPasswordEmailRequest(r);
      return this.http.post(this._host + "/sales.v1.Sales/SendResetPasswordEmail", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  SalesApiService.ɵfac = function SalesApiService_Factory(t) {
    return new (t || SalesApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  SalesApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SalesApiService,
    factory: SalesApiService.ɵfac,
    providedIn: 'root'
  });
  return SalesApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let SalesActivityApiService = /*#__PURE__*/(() => {
  class SalesActivityApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getMulti(r) {
      const request = r.toApiJson ? r : new GetMultiSalesActivityRequest(r);
      return this.http.post(this._host + "/sales.v1.SalesActivityService/GetMulti", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiSalesActivityResponse.fromProto(resp)));
    }
    create(r) {
      const request = r.toApiJson ? r : new CreateSalesActivityRequest(r);
      return this.http.post(this._host + "/sales.v1.SalesActivityService/Create", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateSalesActivityResponse.fromProto(resp)));
    }
  }
  SalesActivityApiService.ɵfac = function SalesActivityApiService_Factory(t) {
    return new (t || SalesActivityApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  SalesActivityApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SalesActivityApiService,
    factory: SalesActivityApiService.ɵfac,
    providedIn: 'root'
  });
  return SalesActivityApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let SalesTeamApiService = /*#__PURE__*/(() => {
  class SalesTeamApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    list(r) {
      const request = r.toApiJson ? r : new ListSalesTeamsRequest(r);
      return this.http.post(this._host + "/sales.v1.SalesTeamService/List", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListSalesTeamsResponse.fromProto(resp)));
    }
    getMulti(r) {
      const request = r.toApiJson ? r : new GetMultiSalesTeamRequest(r);
      return this.http.post(this._host + "/sales.v1.SalesTeamService/GetMulti", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiSalesTeamResponse.fromProto(resp)));
    }
    getMembers(r) {
      const request = r.toApiJson ? r : new GetMembersRequest(r);
      return this.http.post(this._host + "/sales.v1.SalesTeamService/GetMembers", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMembersResponse.fromProto(resp)));
    }
    getTeamsBySalespersons(r) {
      const request = r.toApiJson ? r : new GetTeamsBySalespersonsRequest(r);
      return this.http.post(this._host + "/sales.v1.SalesTeamService/GetTeamsBySalespersons", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetTeamsBySalespersonsResponse.fromProto(resp)));
    }
    updateTeamName(r) {
      const request = r.toApiJson ? r : new UpdateTeamNameRequest(r);
      return this.http.post(this._host + "/sales.v1.SalesTeamService/UpdateTeamName", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  SalesTeamApiService.ɵfac = function SalesTeamApiService_Factory(t) {
    return new (t || SalesTeamApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  SalesTeamApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SalesTeamApiService,
    factory: SalesTeamApiService.ɵfac,
    providedIn: 'root'
  });
  return SalesTeamApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let TasksApiService = /*#__PURE__*/(() => {
  class TasksApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createSalesTask(r) {
      const request = r.toApiJson ? r : new CreateSalesTaskRequest(r);
      return this.http.post(this._host + "/sales.v1.Tasks/CreateSalesTask", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateSalesTaskResponse.fromProto(resp)));
    }
    assignSalesTask(r) {
      const request = r.toApiJson ? r : new AssignSalesTaskRequest(r);
      return this.http.post(this._host + "/sales.v1.Tasks/AssignSalesTask", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  TasksApiService.ɵfac = function TasksApiService_Factory(t) {
    return new (t || TasksApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  TasksApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: TasksApiService,
    factory: TasksApiService.ɵfac,
    providedIn: 'root'
  });
  return TasksApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let UserActionsProviderApiService = /*#__PURE__*/(() => {
  class UserActionsProviderApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    uploadUserAction(r) {
      const request = r.toApiJson ? r : new UserActionsRequest(r);
      return this.http.post(this._host + "/sales.v1.UserActionsProvider/UploadUserAction", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    uploadUserActionForCustomerId(r) {
      const request = r.toApiJson ? r : new UploadUserActionForCustomerIDRequest(r);
      return this.http.post(this._host + "/sales.v1.UserActionsProvider/UploadUserActionForCustomerID", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    bulkUploadUserActions(r) {
      const request = r.toApiJson ? r : new BulkUploadUserActionsRequest(r);
      return this.http.post(this._host + "/sales.v1.UserActionsProvider/BulkUploadUserActions", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listUserActions(r) {
      const request = r.toApiJson ? r : new GetUserActionsRequest(r);
      return this.http.post(this._host + "/sales.v1.UserActionsProvider/ListUserActions", request.toApiJson(), this.apiOptions()).pipe(map(resp => UserActionsResponse.fromProto(resp)));
    }
  }
  UserActionsProviderApiService.ɵfac = function UserActionsProviderApiService_Factory(t) {
    return new (t || UserActionsProviderApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  UserActionsProviderApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: UserActionsProviderApiService,
    factory: UserActionsProviderApiService.ɵfac,
    providedIn: 'root'
  });
  return UserActionsProviderApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let SalespersonService = /*#__PURE__*/(() => {
  class SalespersonService {
    constructor(_api) {
      this._api = _api;
    }
    /**  @deprecated Use getSalespersonBySubjectId or getSalespersonByUserId */
    getSalesperson(partnerId, salespersonId, userId) {
      return salespersonId ? this.getSalespersonBySubjectId(partnerId, salespersonId) : this.getSalespersonByUserId(partnerId, userId || '');
    }
    getSalespersons(partnerId, markets, options) {
      const params = {
        partnerId: partnerId,
        marketIds: markets,
        includeLastLogin: options?.includeLastLogin ?? false
      };
      if (!!options?.searchTerm) {
        params.searchTerm = options.searchTerm;
      }
      if (!!options?.pageSize && !!options?.cursor) {
        params.pagingOptions = {
          pageSize: options.pageSize,
          cursor: options.cursor
        };
      }
      if (!!options?.pageSize && !options?.cursor) {
        params.pagingOptions = {
          pageSize: options.pageSize
        };
      }
      return this._api.lookupSalespersons(params).pipe(map(r => r.salespersons));
    }
    getSalespersonBySubjectId(partnerId, salespersonId) {
      return this._api.getSalesperson({
        partnerId: partnerId,
        salespersonId: salespersonId
      });
    }
    getSalespersonByUserId(partnerId, userId) {
      return this._api.getSalesperson({
        partnerId: partnerId,
        userId: userId
      });
    }
    listSalespersons(filters, cursor, pageSize) {
      return this._api.listSalespersons({
        filters: filters,
        pagingOptions: {
          cursor: cursor,
          pageSize: pageSize
        }
      }).pipe(map(resp => {
        return {
          results: resp.salespersons,
          nextCursor: resp.pagingMetadata.nextCursor,
          hasMore: resp.pagingMetadata.hasMore
        };
      }));
    }
    getAssignedSalespersonForPartner(partnerId, marketId) {
      return this._api.getAssignedSalespersonForPartner({
        partnerId: partnerId,
        marketId: marketId
      });
    }
    sendResetPasswordEmail(partnerId, salespersonId) {
      return this._api.sendResetPasswordEmail({
        partnerId: partnerId,
        salespersonId: salespersonId
      });
    }
    getMultiSalesperson(partnerId, salespersonIds) {
      return this._api.getMultiSalesperson({
        partnerId: partnerId,
        salespersonIds: salespersonIds
      }).pipe(map(resp => resp.salespersons));
    }
  }
  SalespersonService.ɵfac = function SalespersonService_Factory(t) {
    return new (t || SalespersonService)(i0.ɵɵinject(SalesApiService));
  };
  SalespersonService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SalespersonService,
    factory: SalespersonService.ɵfac,
    providedIn: 'root'
  });
  return SalespersonService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PagedResponse$2 = class PagedResponse {
  constructor(results, nextCursor, hasMore) {
    this.results = results;
    this.nextCursor = nextCursor;
    this.hasMore = hasMore;
  }
};
let SalesTeamService = /*#__PURE__*/(() => {
  class SalesTeamService {
    constructor(_api) {
      this._api = _api;
    }
    list(partnerId, marketId, cursor, pageSize) {
      return this._api.list({
        filters: {
          partnerId: partnerId,
          marketId: marketId
        },
        pagingOptions: {
          cursor: cursor,
          pageSize: pageSize
        }
      }).pipe(map(resp => ({
        results: resp.salesTeams,
        nextCursor: resp.pagingMetadata.nextCursor,
        hasMore: resp.pagingMetadata.hasMore
      })));
    }
    getMembers(groupId) {
      return this._api.getMembers({
        groupId: groupId
      }).pipe(map(resp => resp.salesPeople || []));
    }
    updateTeamName(groupId, newTeamName) {
      return this._api.updateTeamName({
        groupId: groupId,
        newTeamName: newTeamName
      }).pipe(mapTo(null));
    }
    getSalesTeamsBySalesperson(salespersonId) {
      return this._api.getTeamsBySalespersons({
        salespersonIds: [salespersonId]
      }).pipe(map(resp => {
        if (!resp || !resp.teamMapping) {
          return [];
        }
        return resp.teamMapping.reduce((salesTeams, mapping) => {
          return [...salesTeams, ...((mapping || {
            salesTeams: []
          }).salesTeams || [])];
        }, []);
      }));
    }
    getMulti(groupIds) {
      return this._api.getMulti({
        groupIds: groupIds
      }).pipe(map(resp => resp.salesTeams || []));
    }
  }
  SalesTeamService.ɵfac = function SalesTeamService_Factory(t) {
    return new (t || SalesTeamService)(i0.ɵɵinject(SalesTeamApiService));
  };
  SalesTeamService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SalesTeamService,
    factory: SalesTeamService.ɵfac,
    providedIn: 'root'
  });
  return SalesTeamService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PagedResponse$1 = class PagedResponse {
  constructor(results, nextCursor, hasMore) {
    this.results = results;
    this.nextCursor = nextCursor;
    this.hasMore = hasMore;
  }
};
let CampaignSDKService = /*#__PURE__*/(() => {
  class CampaignSDKService {
    constructor(campaignApiService) {
      this.campaignApiService = campaignApiService;
    }
    getMultiCampaigns(partnerId, marketId, accountGroupId, campaignIds) {
      return this.campaignApiService.getMultiCampaigns({
        partnerId: partnerId,
        marketId: marketId,
        accountGroupId: accountGroupId,
        campaignIds: campaignIds
      }).pipe(map(resp => resp.campaigns));
    }
    lookupCampaigns(partnerId, marketId, searchTerm, options) {
      const request = {
        partnerId: partnerId,
        marketId: marketId
      };
      if (!!searchTerm) {
        request.searchTerm = searchTerm;
      }
      request.offset = options?.offset || request.offset;
      request.pageSize = options?.pageSize || request.pageSize;
      request.focus = options?.filters?.focus || request.focus;
      request.state = options?.filters?.state || request.state;
      request.status = options?.filters?.status || request.status;
      return this.campaignApiService.lookupCampaigns(request).pipe(map(resp => resp.campaigns));
    }
  }
  CampaignSDKService.ɵfac = function CampaignSDKService_Factory(t) {
    return new (t || CampaignSDKService)(i0.ɵɵinject(CampaignApiService));
  };
  CampaignSDKService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CampaignSDKService,
    factory: CampaignSDKService.ɵfac,
    providedIn: 'root'
  });
  return CampaignSDKService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const defaultOptions = {
  withCredentials: true
};
let Businesses = /*#__PURE__*/(() => {
  class Businesses {
    constructor(internal) {
      this.internal = internal;
    }
    search(partnerId, marketId, sortKey, sortAscending, searchOptions) {
      const options = searchOptions || {};
      const request = {
        filters: {
          partnerId: partnerId,
          marketId: marketId,
          query: options.searchTerm,
          salesStatuses: options.salesStatuses,
          salesAction: options.salesAction,
          fromDate: options.fromDate,
          toDate: options.toDate,
          archived: options.archived,
          accountTags: options.accountTags,
          businessCategories: options.businessCategories,
          onCampaign: options.onCampaign,
          snapshotSent: options.snapshotSent,
          assignees: options.assignees,
          goal: options.goal,
          trainingPriorities: options.trainingPriorities,
          customFieldPartnerId: options.customFieldPartnerId,
          lifecycleStage: options.lifecycleStage
        },
        pagingOptions: {
          cursor: options.cursor,
          pageSize: options.pageSize
        },
        sortOptions: {
          sortKey: sortKey,
          sortAscending: sortAscending
        }
      };
      return this.internal.search(request).pipe(map(resp => {
        const respBusinesses = resp.businesses || [];
        return {
          pagingMetadata: resp.pagingMetadata,
          businesses: respBusinesses
        };
      }), share());
    }
    requestSubscriptionChange(businessId, name, phoneNumber, message) {
      return this.internal.requestSubscriptionChange({
        businessId: businessId,
        message: message,
        phoneNumber: phoneNumber,
        name: name
      }).pipe(map(() => true));
    }
  }
  Businesses.ɵfac = function Businesses_Factory(t) {
    return new (t || Businesses)(i0.ɵɵinject(BusinessApiService));
  };
  Businesses.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: Businesses,
    factory: Businesses.ɵfac,
    providedIn: 'root'
  });
  return Businesses;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let UserActionService = /*#__PURE__*/(() => {
  class UserActionService {
    constructor(_api) {
      this._api = _api;
    }
    listUserActions(accountGroupId, cursor, pageSize) {
      return this._api.listUserActions({
        accountGroupId: accountGroupId,
        cursor: cursor,
        pageSize: pageSize
      }).pipe(map(resp => ({
        results: resp.userActions,
        nextCursor: resp.pagingMetadata.nextCursor,
        hasMore: resp.pagingMetadata.hasMore
      })));
    }
  }
  UserActionService.ɵfac = function UserActionService_Factory(t) {
    return new (t || UserActionService)(i0.ɵɵinject(UserActionsProviderApiService));
  };
  UserActionService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: UserActionService,
    factory: UserActionService.ɵfac,
    providedIn: 'root'
  });
  return UserActionService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class PagedResponse {
  constructor(results, nextCursor, hasMore) {
    this.results = results;
    this.nextCursor = nextCursor;
    this.hasMore = hasMore;
  }
}

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var DiscountType = /*#__PURE__*/function (DiscountType) {
  DiscountType[DiscountType["DISCOUNT_TYPE_NO_DISCOUNT"] = 0] = "DISCOUNT_TYPE_NO_DISCOUNT";
  DiscountType[DiscountType["DISCOUNT_TYPE_PERCENTAGE"] = 1] = "DISCOUNT_TYPE_PERCENTAGE";
  DiscountType[DiscountType["DISCOUNT_TYPE_FIXED_AMOUNT"] = 2] = "DISCOUNT_TYPE_FIXED_AMOUNT";
  return DiscountType;
}(DiscountType || {});
var SortFields = /*#__PURE__*/function (SortFields) {
  SortFields[SortFields["SORT_FIELDS_CREATED"] = 0] = "SORT_FIELDS_CREATED";
  SortFields[SortFields["SORT_FIELDS_UPDATED"] = 1] = "SORT_FIELDS_UPDATED";
  return SortFields;
}(SortFields || {});
let FreshdeskService = /*#__PURE__*/(() => {
  class FreshdeskService {
    constructor(_api) {
      this._api = _api;
    }
    getConfiguration(partnerId) {
      return this._api.getConfiguration(new GetConfigurationRequest({
        partnerId: partnerId
      }));
    }
    setConfiguration(partnerId, domain, apiKey) {
      const r = new SetConfigurationRequest({
        partnerId: partnerId,
        domain: domain,
        apiKey: apiKey
      });
      const errorInterceptor = httpResponse => httpResponse.pipe(switchMap(res => res.ok ? EMPTY : throwError(res.status)));
      return this._api.setConfiguration(r).pipe(errorInterceptor);
    }
    /**
     * Retrieves all tickets from Freshdesk for a given account group id
     * @param partnerID - Scopes the ticket search to a specific partner
     * @param accountGroupID - Scopes the ticket search to a particular accountGroupID
     * @param pagination - Includes pageIndex and pageSize used for paginating results
     *
     * @remarks
     * Freshdesk's API and the underlying µs explicitly uses 1-based page indexing, however this SDK uses 0-based page indexing.
     * Supplying `pageIndex=0` results in a call to the datasource using `pageIndex=1`
     **/
    searchTickets(partnerID, accountGroupID, pagination) {
      const req = new SearchTicketsRequest({
        pagination: {
          ...pagination,
          pageIndex: (pagination?.pageIndex || 0) + 1
        },
        accountGroupId: accountGroupID,
        partnerId: partnerID
      });
      return this._api.searchTickets(req).pipe(map(resp => {
        return resp.tickets ?? [];
      }));
    }
    viewTicket(partnerID, accountGroupId, ticketId, includeFields) {
      const req = new ViewTicketRequest({
        partnerId: partnerID,
        accountGroupId: accountGroupId,
        ticketId: ticketId,
        includeFields: includeFields
      });
      return this._api.viewTicket(req);
    }
  }
  FreshdeskService.ɵfac = function FreshdeskService_Factory(t) {
    return new (t || FreshdeskService)(i0.ɵɵinject(FreshdeskApiService));
  };
  FreshdeskService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: FreshdeskService,
    factory: FreshdeskService.ɵfac,
    providedIn: "root"
  });
  return FreshdeskService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PartnerService = /*#__PURE__*/(() => {
  class PartnerService {
    constructor(_api) {
      this._api = _api;
    }
    getPartnerSalesDomain(partnerId) {
      const r = new PartnerSalesDomainRequest({
        partnerId: partnerId
      });
      return this._api.getPartnerSalesDomain(r).pipe(map(resp => resp.domain));
    }
    updatePartnerSalesDomain(partnerId, domain) {
      const r = new UpdatePartnerSalesDomainRequest({
        partnerId: partnerId,
        domain: domain
      });
      return this._api.updatePartnerSalesDomain(r).pipe(mapTo(null));
    }
  }
  PartnerService.ɵfac = function PartnerService_Factory(t) {
    return new (t || PartnerService)(i0.ɵɵinject(PartnerApiService));
  };
  PartnerService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: PartnerService,
    factory: PartnerService.ɵfac,
    providedIn: 'root'
  });
  return PartnerService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TasksService = /*#__PURE__*/(() => {
  class TasksService {
    constructor(_api) {
      this._api = _api;
    }
    createSalesTask(title, partnerId, marketId, accountGroupId, dueDate, salespersonIds) {
      const req = {
        partnerId: partnerId,
        marketId: marketId,
        accountGroupId: accountGroupId,
        dueDate: dueDate,
        salespersonIds: salespersonIds,
        title: title
      };
      return this._api.createSalesTask(req).pipe(switchMap(resp => {
        if (!resp.taskId) {
          return throwError('No task ID returned');
        }
        if (!resp.taskNamespace) {
          return throwError('No task namespace returned');
        }
        return of({
          taskId: resp.taskId,
          taskNamespace: resp.taskNamespace
        });
      }));
    }
    assignSalesTask(partnerId, marketId, taskId, salespersonUserId, accountGroupId) {
      const req = {
        partnerId: partnerId,
        marketId: marketId,
        accountGroupId: accountGroupId,
        taskId: taskId,
        salespersonUserId: salespersonUserId
      };
      return this._api.assignSalesTask(req).pipe(map(v => v.body));
    }
  }
  TasksService.ɵfac = function TasksService_Factory(t) {
    return new (t || TasksService)(i0.ɵɵinject(TasksApiService));
  };
  TasksService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: TasksService,
    factory: TasksService.ɵfac,
    providedIn: 'root'
  });
  return TasksService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { Archived, AutoAssignCriteria, AutoAssignCriteriaAccountOriginCriteria, AutoAssignCriteriaCategoryCriteria, AutoAssignCriteriaConversionPointCriteria, AutoAssignCriteriaLocationCriteria, AutoAssignCriteriaTagCriteria, AutoAssignRule, Businesses, Campaign, CampaignSDKService, CriteriaMatchType, DiscountType, FreshdeskService, GetAutoAssignConfigResponse, LifecycleStage, PagedResponse$1 as PagedResponse, PartnerService, SalesApiService, SalesTeamService, Salesperson, SalespersonService, Snapshot, SortFields, TagMatchType, TasksService, TicketPriority, UserAction, UserActionService };
